var exports = {
  "wx": "MobileSettingsView.module__header___VGRYb3",
  "VW": "MobileSettingsView.module__headerContent___VGRYb3",
  "pS": "MobileSettingsView.module__headerContentRelative___VGRYb3",
  "lt": "MobileSettingsView.module__bannerTextContainer___VGRYb3",
  "_M": "MobileSettingsView.module__bannerText___VGRYb3",
  "BM": "MobileSettingsView.module__bannerTextWhite___VGRYb3",
  "yp": "MobileSettingsView.module__bannerTextPrimary___VGRYb3",
  "gG": "MobileSettingsView.module__bannerActions___VGRYb3",
  "Gv": "MobileSettingsView.module__backButton___VGRYb3",
  "qd": "MobileSettingsView.module__headerTitle___VGRYb3",
  "aF": "MobileSettingsView.module__headerActionSlot___VGRYb3",
  "BJ": "MobileSettingsView.module__icon5___VGRYb3",
  "gs": "MobileSettingsView.module__scrollerContainer___VGRYb3",
  "Wy": "MobileSettingsView.module__categorySection___VGRYb3",
  "p8": "MobileSettingsView.module__categoryTitle___VGRYb3",
  "jv": "MobileSettingsView.module__categoryList___VGRYb3",
  "tl": "MobileSettingsView.module__settingsItem___VGRYb3",
  "ZF": "MobileSettingsView.module__settingsItemPressed___VGRYb3",
  "QS": "MobileSettingsView.module__settingsItemIcon___VGRYb3",
  "ec": "MobileSettingsView.module__settingsItemContent___VGRYb3",
  "CR": "MobileSettingsView.module__settingsItemLabelContainer___VGRYb3",
  "yU": "MobileSettingsView.module__settingsItemSpinner___VGRYb3",
  "N5": "MobileSettingsView.module__settingsItemLabel___VGRYb3",
  "o9": "MobileSettingsView.module__settingsItemArrow___VGRYb3",
  "x": "MobileSettingsView.module__settingsItemExternalIcon___VGRYb3",
  "yF": "MobileSettingsView.module__divider___VGRYb3",
  "lk": "MobileSettingsView.module__clientInfoContainer___VGRYb3",
  "hQ": "MobileSettingsView.module__contentContainer___VGRYb3",
  "Yd": "MobileSettingsView.module__scrollerFlex___VGRYb3",
  "rZ": "MobileSettingsView.module__profileSection___VGRYb3",
};

module.exports = exports;
